export enum BoardType {
  GROUP = 'group',
  COMPARISON = 'comparison',
}

export enum SaleStatus {
  ACTIVE = 'active',
  CLOSED = 'closed',
}

export enum SettlementStatus {
  SETTLED = 'settled',
  IN_PROGRESS = 'in_progress',
  PENDING = 'pending',
}

export interface BoardKeyMetric {
  type: 'pending_balance' | 'comparison_delta';
  value: number;
  positive?: boolean;
}

export interface BoardDTO {
  id: string;
  business_id: string;
  name: string;
  type: BoardType;
  event_ids: string[];
  updated_at: string;
  computed_at?: string;
  key_metric?: BoardKeyMetric;
}

export interface CreateBoardPayload {
  name: string;
  type: BoardType;
  event_ids: string[];
}

export interface UpdateBoardPayload {
  name?: string;
  event_ids?: string[];
}

export interface BoardEventMetrics {
  event_id: string;
  name: string;
  date: string;
  sale_status: SaleStatus;
  is_cancelled: boolean;
  gross_sales: number;
  net_sales: number;
  paid_tickets: number;
  free_tickets: number;
  tickets_per_purchase: number;
  average_ticket: number;
  settlement_status: SettlementStatus;
  pending_balance: number;
  currency: string;
}

export interface BoardGroupSummary {
  gross_sales: number;
  net_sales: number;
  paid_tickets: number;
  settled_amount: number;
  pending_balance: number;
  mixed_currency_blocked: boolean;
}

export interface PaceChartPoint {
  days_before_event: number;
  label: string;
  reference_tickets: number | null;
  counterpart_tickets: number | null;
}

export interface BoardComparisonSummary {
  delta_percent: number;
  delta_tickets: number;
  reference_event_name: string;
  counterpart_event_name: string;
  both_closed: boolean;
  reference_days_before_event: number;
  reference_metrics: BoardEventMetrics;
  counterpart_metrics: BoardEventMetrics;
  pace_chart: PaceChartPoint[];
  metric_comparison: {
    average_ticket: { reference: number; counterpart: number };
    tickets_per_purchase: { reference: number; counterpart: number };
    paid_tickets_at_point: { reference: number; counterpart: number };
    free_tickets_at_point: { reference: number; counterpart: number };
    comparison_days_before_event: number;
  };
}

export interface BoardDetailDTO extends BoardDTO {
  computed_at: string;
  group_summary?: BoardGroupSummary;
  event_metrics: BoardEventMetrics[];
  comparison_summary?: BoardComparisonSummary;
  read_only?: boolean;
}

export type BoardExportFormat = 'csv' | 'pdf';

// Liquidación masiva de un tablero grupo (solo ROOT): una transferencia
// aprobada por evento con saldo pendiente, todas con los mismos datos.
export interface CreateBoardSettlementPayload {
  bank_account_id: string;
  description?: string;
  receipt_pdf_url: string;
  transfer_date?: string;
  expected_total: number;
}

export interface BoardSettlementItemDTO {
  event_id: string;
  event_name: string;
  amount: number;
  wire_transfer_id: string;
  wire_request_id: string;
}

export type BoardSettlementSkipReason = 'cancelled' | 'no_balance';

export interface BoardSettlementSkippedDTO {
  event_id: string;
  event_name: string;
  reason: BoardSettlementSkipReason;
}

export interface BoardSettlementResultDTO {
  batch_id: string;
  total: number;
  settled: BoardSettlementItemDTO[];
  skipped: BoardSettlementSkippedDTO[];
}
